import {Injectable, NgModule} from '@angular/core';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import {AuthDataManager} from '../../data/auth.datamanager';
import {SessionService} from './session.service';
import {UsersDataManager} from '../users.datamanager';

@Injectable()
export class AuthGuard {
  constructor(
      private authDataManager: AuthDataManager,
      private sessionService: SessionService,
      private usersDataManager: UsersDataManager,
      private router: Router) {}

  canActivate() {
    if (!this.authDataManager.isLoggedIn()) {
      this.router.navigate(['/login']);
      return false;
    }

    if (this.authDataManager.requiresTwoFactorSetup()) {
      return true;
    }

    return this.usersDataManager.getLoggedInUser()
        .map(() => true)
        .catch((error) => {
          this.sessionService.handleAuthenticatedRequestError(error);
          return Observable.of(false);
        });
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/authGuard.ts